import { ReactNode, forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Text, TextProps } from '@backstage/ui';

const styles = createStyles({
  root: {
    fontWeight: 600,
  },
});

export interface TitleProps extends TextProps, WithStyles<typeof styles> {
  children: ReactNode;
}

const Title = forwardRef<HTMLDivElement, TitleProps>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <Text
      ref={ref}
      as="div"
      variant="title-x-small"
      className={classNames(classes.root, className)}
      {...rest}
    >
      {children}
    </Text>
  );
});

Title.displayName = 'ActivityFeedItem.Title';

export default withStyles(styles)(Title);
